@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";
@use "../../styles/mixins";

.wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
}

.container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    row-gap: 100px;
    margin-bottom: 2rem;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr 1fr;
    }
}

.heading {
    font-family: Chalk, monospace;
    font-size: 2.5rem;
    margin: 4.625rem 0 2rem;
}

.fineprint {
    font-size: 12px;
    font-style: italic;
    text-align: center;
}

.link {
    display: block;
    padding: 15%;
    text-decoration: none;
}

.linkTitle {
    @include mixins.chalk-lines;

    font-family: Chalk, monospace;
    font-size: 2.5rem;
    color: var(--text-color);
    text-align: center;
    text-transform: uppercase;
}
